import React from 'react';
import { Tooltip } from 'react-tooltip';
import MenuAdministrativos from './MenuAdministrativos';
import MenuAdministrativosRei from '../../Reincorporados/Informes/MenuAdministrativosRei';
import MenuInformeDdhh from '../../ddhh/MenuInformeDdhh';

export default function VerInformeAdministrativo(){
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Informes administrativos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Informes</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuAdministrativos></MenuAdministrativos>
                    <MenuAdministrativosRei></MenuAdministrativosRei>
                    <MenuInformeDdhh></MenuInformeDdhh>
                </div>
            </section>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}